<template>
  <div class="animated fadeIn manage-staffing-page-container">
    <div class="container-fluid search-session bg-white">
      <div class="row">
        <div class="col-md-4 col-sm-6">
          <b-input-group>
            <b-form-input class="placeholder-italic" v-model.lazy="keyword" type="text"
                          placeholder="Search by staff name" :formatter="format"></b-form-input>
            <div class="search-icon"></div>
          </b-input-group>
        </div>
        <div class="col-md-8 col-sm-6 text-right">
          <!--<b-button class="ap-btn primary btn-blue" @click="createNewTempStaff()">
            CREATE
          </b-button>-->
        </div>
      </div>
    </div>
    <div class="staffing-table">
      <div class="table-title" v-if="staffList.length !== 0">
        <StaffingHeader :pagingObj="pagingObj" v-on:CHANGE_PAGING_OPTIONS="changePagingOptions"/>
      </div>
      <div class="loading-staffing" :class="{'isLoading': getLoading, 'noDisplay': !getLoading}">
        <Icon name="spinner" scale="5" pulse class="icon-size"/>
      </div>
      <div id="dt-body">
        <StaffingRow v-for="(item, index) in staffList" class="event-row-wrapper" :item="item" :index="index" :key="item"
                     v-on:getListStaff="getAllStaff"></StaffingRow>
        <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading" :distance="100" >
          <Spinner slot="spinner"></Spinner>
          <div slot="no-more" class="infinite-status-prompt"></div>
          <div slot="no-results" class="infinite-status-prompt"></div>
        </infinite-loading>
        <!--<div class="none-items" v-if="staffList.length === 0">
          <div class="none-items-text">
            add a staff member
          </div>
          <b-button class="ap-btn primary btn-blue" @click="createNewTempStaff()">
            CREATE
          </b-button>
        </div>-->
      </div>
    </div>
    <ScrollTop/>
    <StaffDetailModal :staffDetail="item"/>
  </div>
</template>

<script>
  import StaffingHeader from '../../../components/staffing/StaffingHeader';
  import StaffingRow from '../../../components/staffing/StaffingRow';
  import ScrollTop from '../../../components/utils/ScrollTop';
  import StaffDetailModal from '@/components/modal/staff/StaffDetailModal';
  import InfiniteLoading from 'vue-infinite-loading';
  import Spinner from '@/components/commons/Spinner';

  // import consts from '../../../_consts';

  import {mapGetters, mapMutations, mapActions} from 'vuex';

  /* Register component with one of 2 methods */
  import 'vue-awesome/icons/spinner';
  import Icon from 'vue-awesome/components/Icon';
  import constants from '../../../_consts';
  import * as _ from 'lodash';
  import DtPaging from '../../../components/datatable/DtPaging';
  const itemPerPage = 20;

  export default {
    name: 'plan-and-approve',
    components: {
      StaffingHeader,
      StaffingRow,
      Icon,
      ScrollTop,
      DtPaging,
      StaffDetailModal,
      InfiniteLoading,
      Spinner
    },
    computed: {
      getHeightOfComp () {
        return 127;
      },
      ...mapGetters({
        getListEvent: 'GETTERS_LIST_EVENT',
        getLoading: 'GETTERS_IS_LOADING_STAFFING',
        staffingList: 'GETTER_GET_STAFF_LIST'
      })
    },
    data () {
      return {
        fixElement: false,
        keyword: '',
        pagingObj: {
          currentPage: 1,
          itemsPerPage: itemPerPage,
          sortType: 'firstName',
          sortReverse: false,
          totalItems: 0
        },
        staffList: []
      }
    },
    methods: {
      infiniteHandler ($state) {
        let vm = this;
        this.getAllStaff()
          .then((res) => {
            if (res && vm.pagingObj.currentPage * vm.pagingObj.itemsPerPage > vm.staffList.length) {
              $state.complete();
            } else {
              $state.loaded();
            }
            vm.pagingObj.currentPage++;
          });
      },
      resetPagingOption () {
        this.pagingObj.currentPage = 1;
        this.pagingObj.itemsPerPage = itemPerPage;
        this.setIdToState(-1);
      },
      changePagingOptions (pagingObj) {
        this.resetPagingOption();
        this.staffList = [];
        this.$refs.infiniteLoading.stateChanger.reset();
      },
      handleScroll () {
        this.fixElement = window.scrollY >= 180;
      },
      getAllStaff (params) {
        return new Promise((resolve, reject) => {
          let body = {
            keyword: this.keyword.toLowerCase(),
            currentPage: this.pagingObj.currentPage,
            itemsPerPage: this.pagingObj.itemsPerPage,
            sortType: this.pagingObj.sortType,
            sortReverse: this.pagingObj.sortReverse,
            ...params
          };

          this.getStaffList(body).then((response) => {
            if (response) {
              this.staffList.push(...response.listStaff);
              resolve(response);
            }
          }).catch(e => {
            reject(e);
          });
        })
      },
      createNewTempStaff () {
        this.staffList = [{
          id: 0,
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          role: '',
          payRates: 0,
          address: '',
          events: '',
          isEditing: true
        }].concat(this.staffList || []);
      },
      ...mapActions({
        getStaffList: 'ACTION_GET_STAFF_LIST'
      }),
      ...mapMutations({
        setIdToState: 'MUTATION_SET_EXPAND_ID',
        saveStaffList: 'MUTATION_SAVE_STAFF_LIST'
      })
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    mounted () {
      this.$store.commit('MUTATION_SET_MANAGER_VIEW', constants.viewNames.staffing);
      if (this.$route.params && this.$route.params.detail) {
        this.$modal.show('staffDetailModal', this.$route.params.detail);
      }
    },
    watch: {
      keyword: _.debounce(function () {
        this.changePagingOptions();
      }, 500)
    }
  }
</script>

<style lang="less" scoped="">
  @import '../../../styles/variables.less';

  .manage-staffing-page-container{
    height: calc(~"100vh - 231px");
    overflow-y: hidden;

    .staffing-table{
      height: calc(~"100% - 124px");
    }
  }

  .icon-size {
    width: 100px;
    height: 100px;
  }

  .loading-staffing {
    clear: both;
    padding-top: 30px;
    text-align: center;
  }

  .noDisplay {
    display: none;
  }

  .table-title {
    height: 40px;
    line-height: 20px;
  }

  .staffing-table {
    padding: 0 15px;
    overflow-x: auto;
  }

  .event-row-wrapper {
    margin: 8px 0;
  }

  .search-session {
    height: 124px;
    padding-top: 35px !important;
    padding-left: 15px !important;
    .placeholder-italic {
      margin-top: 10px;
      border: 1px solid @grey-6;
      padding: 3px 15px;
      font-family: 'Open Sans', sans-serif;
      height: 42px;
      border-radius: 3px;
      background-color: @white;
    }
    .search-icon {
      width: 26px;
      height: 26px;
      color: @light-blue;
      background-color: @light-blue;
      position: absolute;
      z-index: 999;
      right: 10px;
      top: 18px;
      -webkit-mask: url('../../../../static/img/search.svg') no-repeat center;
      mask: url('../../../../static/img/search.svg') no-repeat center;
      background: url('../../../../static/img/search-blue.svg');
    }

    .btn-create-client {
      position: relative;
      width: 150px;
      .icon-add-client {
        z-index: 999;
        color: @white;
        background-color: @blue;
        width: 27px;
        height: 27px;
        border-radius: 15px;
        margin-top: 17px;
        display: inline-block;
      }
      .btn-text {
        display: inline-block;
        position: absolute;
        top: 18px;
        left: 35px;
      }
    }
    .btn-blue {
      margin-right: 15px;
      margin-top: 20px;
    }

    .ap-btn{
      padding: 6px 24px;
    }
  }

  .none-items {
    text-align: center;
    .none-items-text {
      height: 16px;
      color: #8E8E8E;
      font-family: "Open Sans", sans-serif;
      font-size: 12px;
      letter-spacing: 0.1px;
      line-height: 16px;
      text-transform: uppercase;
      margin: 75px auto 15px;
    }

    .ap-btn{
      padding: 6px 24px;
    }
  }

</style>



// WEBPACK FOOTER //
// StaffingSection.vue?54d3ea1f